import { ReactElement } from 'react';

import { QSpinner, QText } from '@qualio/ui-components';

const ActiveStatusFilter = ({
  value,
  statusMap,
}: {
  value: unknown;
  statusMap: Record<string, string>;
}): ReactElement => {
  const id = value as string;
  const status = statusMap[id];
  if (status) {
    return <QText as="span">{status}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveStatusFilter;
